import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { AdminsService } from '../services/admins.service';

export const adminGuard = async () => {
  const authService = inject(AuthService);
  const adminsService = inject(AdminsService);
  const router = inject(Router);

  if (await authService.isAuthenticated() && await authService.isAdmin()) {
    // Populate the shared admins signal (once) for use across the admin app.
    void adminsService.ensureLoaded();
    return true;
  }

  if (await authService.isAuthenticated()) {
    // User is authenticated but not admin - redirect to user dashboard
    router.navigate(['/user/companies']);
  } else {
    // User is not authenticated - redirect to login
    router.navigate(['/auth/login']);
  }

  return false;
};
